export default __webpack_public_path__ + "static/handsome-creative-ATLC-print-design-bd03b7e74c6d9b54fe0f1c2eca9cd1f8.jpg";